// extracted by mini-css-extract-plugin
export var notificationHost = "_kr-0";